import * as ActionTypes from '../../actions/actionTypes'

const initialState = {
    pendingPushYearPrices: false,
    pendingCheckAndPullOrders: false,
    pendingInventoryAvailability: false
}

/** @reducer **/
export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.HW_PUSH_YEAR_PRICES_REQUEST:
            return { ...state, pendingPushYearPrices: true }
        case ActionTypes.HW_PUSH_YEAR_PRICES_SUCCESS:
        case ActionTypes.HW_PUSH_YEAR_PRICES_FAILURE:
            return { ...state, pendingPushYearPrices: false }

        case ActionTypes.HW_CHECK_AND_PULL_ORDERS_REQUEST:
            return { ...state, pendingCheckAndPullOrders: true }
        case ActionTypes.HW_CHECK_AND_PULL_ORDERS_SUCCESS:
        case ActionTypes.HW_CHECK_AND_PULL_ORDERS_FAILURE:
            return { ...state, pendingCheckAndPullOrders: false }

        case ActionTypes.HW_INVENTORY_AVAILABILITY_REQUEST:
            return { ...state, pendingInventoryAvailability: true }
        case ActionTypes.HW_INVENTORY_AVAILABILITY_SUCCESS:
        case ActionTypes.HW_INVENTORY_AVAILABILITY_FAILURE:
            return { ...state, pendingInventoryAvailability: false }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/hostelWorldReducers/hwSync.js